import { Fragment } from 'react'

import { Menu, Transition } from '@headlessui/react'
import { getNames } from 'country-list'

import { Icon } from '../Icon'
import { Typography } from '../Typography'

const COUNTRY_LIST = getNames()

export function CountryDropdown({
  value,
  onChange,
  error,
}: {
  value?: string
  onChange: (val: string) => void
  error?: string
}) {
  const selectedCountry = COUNTRY_LIST?.find(
    (country: string) => country === value,
  )

  return (
    <div className="w-full text-right">
      <Menu as="div" className="relative inline-block text-left w-full">
        <div>
          <Menu.Button className="flex items-center justify-between border-b border-dark-border hover:border-dark-typo-gray w-full bg-opacity-20 py-2 text-sm font-medium">
            <Typography
              fontWeight="normal"
              color={selectedCountry ? 'primary' : 'secondary'}
            >
              {selectedCountry ? selectedCountry : 'Select country'}
            </Typography>
            <Icon size={18} color="secondary" name="chevronDown" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="mt-1 border border-dark-border absolute right-0 w-full bg-dark-card origin-top-right divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
            <div className="px-1 py-1">
              {COUNTRY_LIST &&
                COUNTRY_LIST.map((country: string) => (
                  <Menu.Item key={country}>
                    {({ active }) => (
                      <button
                        type="button"
                        className={`${
                          active
                            ? 'bg-violet-500 text-white bg-dark-gray-primary'
                            : 'border-dark-typo-gray'
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                        onClick={() => {
                          onChange(country)
                        }}
                      >
                        {country}
                      </button>
                    )}
                  </Menu.Item>
                ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
      {error && (
        <span className="absolute left-0 bottom-[-1.5em] text-red-500 text-sm text-red font-medium">
          {error}
        </span>
      )}
    </div>
  )
}
